// composants/SkeletonCard.jsx
export default function SkeletonCard() {
  return (
    <div className="animate-pulse rounded-2xl bg-white shadow">
      <div className="aspect-square bg-gray-200 rounded-t-2xl" />
      <div className="p-4 space-y-3">
        <div className="h-5 bg-gray-200 rounded w-3/4" />
        <div className="h-4 bg-gray-200 rounded w-full" />
        <div className="h-6 bg-gray-200 rounded w-1/2" />
      </div>
    </div>
  );
}